import { render, staticRenderFns } from "./AddressRow.vue?vue&type=template&id=661e24f1&lang=pug&"
import script from "./AddressRow.vue?vue&type=script&lang=js&"
export * from "./AddressRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports